module.exports = __webpack_public_path__ + "img/sneezing-face.e499bd20.png";